import { render, staticRenderFns } from "./DeveloperTreeNode.vue?vue&type=template&id=2852bffb"
import script from "./DeveloperTreeNode.vue?vue&type=script&lang=js"
export * from "./DeveloperTreeNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports